import React from 'react';
import { Spin, Empty } from 'antd';
import { useArchivesPageManager } from '../../contexts/ArchivesPageManager/Provider';
import CardsContainer from './components/CardsContainer';
import Pagination from './components/Pagination';

export default function Content() {
  const { loadingArchives, archives } = useArchivesPageManager();

  if (loadingArchives) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          height: '100px',
        }}
      >
        <Spin />
      </div>
    );
  }

  if (archives.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          height: '100px',
        }}
      >
        <Empty />
      </div>
    );
  }

  return (
    <>
      <CardsContainer />
      <Pagination />
    </>
  );
}
